<template>
	<div class="text-center">
		<img src="@/assets/image/loading-dots.svg" width="40" height="40" class="m-auto">
	</div>
</template>